export const AB_TEST_NAMES = [];
/**
 * HOW to use:
 *
 * перечисляем названия кук для тестов (согласовать с аналитиками)
 * (сохраняем в переменную, чтобы потом использовать в селекторе selectABVariant)
 *
 * export const TEST_1 = 'test-1;
 * export const TEST_2 = 'test-2;
 *
 * добавляем в массив все запущенные тесты
 *
 * export const AB_TEST_NAMES = [TEST_1, TEST_2];  // TEST_1 и TEST_2 запущены параллельно
 *
 * Пример получения варианта:
 *
 * const variant = useSelector(selectABVariant(TEST_1));
 *
 * if (variant === 'B) {
 *  // do something
 * }
 */
